import includeApi from '../../api/include.api'

const state = {};

const getters = {
    downloadExcelList: () => (id, time) => {
        return includeApi.downloadExcel(id, time);
    }
};

const mutations = {};

const actions = {
    getIncludeList({commit}, params) {
        return includeApi.getInclude(params);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/include.js